import {RestService} from "./rest-api.js";
import {http} from "@/mdk/auth-api";
import Vue from "vue";
import MDKTable from "@/mdk/MDKTable2";
import MDKForm from "@/mdk/MDKForm";
import MDKInput from "@/mdk/MDKInput";
import MDKTagsInput from "@/mdk/MDKTagsInput";
import MDKChart from "@/mdk/MDKChart";
import {AuthApi} from "@/mdk/auth-api.js";

Vue.component("MDKTable", MDKTable)
Vue.component("MDKForm", MDKForm)
Vue.component("MDKInput", MDKInput)
Vue.component("MDKTagsInput", MDKTagsInput)
Vue.component("MDKChart", MDKChart)

Vue.prototype.$MDKOptions = {
    rowFilterPlaceholder: '전체',
    readonlyInputPlaceholder: '-'
}

/** MDK-OAuth 사용 시, AuthApi 를 상속한다. */
export const _service = new RestService();

async function getAllCode() {
    const res = await http.get(`/onmapi/utils/code/all`)

    return res.data;
}

//2023-12-27 mapcode삭제
// async function getMapCode() {
//     const mapRes = await http.get(`/me/filter/mapcode`)
//
//     return mapRes.data.code_table;
// }

export class Application extends AuthApi {
    constructor(router) {
        super(router, "/login")
        this.service = _service;
        this.code = {};
        this.mapCode = [];

        getAllCode()
            .then(res => {
                this.code = res;
            })

        // getMapCode()
        //   .then(mapRes => {
        //       this.mapCode = mapRes;
        //   })
    }

    async http_post(url, data) {
        const res = await http.post(url, data)
        return res.data;
    }

    async http_get(url, data) {
        const res = await http.get(url, data)
        return res.data;
    }


}

